import React from "react";

import styles from './members.module.scss';
import KoDP from "packages/dp";
import { KoText } from "packages/typography";

function KoStaicGroups(props) {
  const { data, size } = props;
  return (
    data?.name && <div className={`profileChar ${styles.membersWrapper}`}>
      <div className={`${styles.circle}  ${data ?
        data?.name?.charAt(0).toLowerCase() : 'a'}`}>
        {data?.['logo'] ?
          <KoDP className={styles.btn} shape={'circle'} logo={data?.logo}
            width={data?.logo?.[0]?.name ? size ? size : 25 : 25}
            height={data?.logo?.[0]?.name ? size ? size : 25 : 25} />
          :
          <KoText className={`${styles.letter}`} text={data?.name?.charAt(0)} />
        }
      </div>
      <div className={styles.memberInfo}>
        <KoText text={`${data?.name}`} className={styles.memberName} />
      </div>
    </div>
  );
}
export default KoStaicGroups;
